import {
    createContext,
    useCallback,
    useContext,
    useEffect,
    useMemo,
    useState,
} from "react";

const ThemeContext = createContext({
    isDarkMode: false,
    setTheme: () => { },
    toggleTheme: () => { },
});

const getInitialTheme = () => {
    if (typeof window === "undefined") return false;
    const stored = localStorage.getItem("darkMode");

    if (stored === "true") return true;
    if (stored === "false") return false;

    return false;
};

const applyThemeClass = (isDarkMode) => {
    if (typeof document === "undefined" || !document.body) return;
    document.body.classList.toggle("dark-mode", isDarkMode);
};

const initialTheme = getInitialTheme();
applyThemeClass(initialTheme);

export const ThemeProvider = ({ children }) => {
    const [isDarkMode, setIsDarkMode] = useState(initialTheme);

    useEffect(() => {
        applyThemeClass(isDarkMode);
        if (typeof window !== "undefined") {
            localStorage.setItem("darkMode", String(isDarkMode));
        }
    }, [isDarkMode]);

    const setTheme = useCallback((value) => {
        setIsDarkMode(Boolean(value));
    }, []);

    const toggleTheme = useCallback(() => {
        setIsDarkMode((prev) => !prev);
    }, []);

    const value = useMemo(
        () => ({ isDarkMode, setTheme, toggleTheme }),
        [isDarkMode, setTheme, toggleTheme]
    );

    return (
        <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
    );
};

export const useTheme = () => useContext(ThemeContext);